import { Link } from "gatsby"
import React from "react"
import Logo from "../../images/pharms-logo.svg"

import { headerSimple, header, wrap } from "../Header/header.module.scss"

export default React.memo(() => {
  return (
    <div className={`${header} ${headerSimple}`}>
      <div className={wrap}>
        <Link
          to="/"
          style={{
            color: `white`,
            textDecoration: `none`,
          }}
        >
          <img
            src={Logo}
            alt="かかりつけ薬局支援システム Pharms（ファームス）"
            width="124px"
          />
        </Link>
      </div>
    </div>
  )
})
